module.exports = __webpack_public_path__ + "img/3_Hanoi_mobility_study_frontcover.0366f43e.jpg";